import { SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  error?: unknown;
  consents?: readonly unknown[];
  allowZeroConsents?: boolean;
}

export function ConsentsSectionMessage(props: Props) {
  const { error, consents, allowZeroConsents = false } = props;

  const { t } = useTranslation();

  return (
    <>
      {error ? (
        <SectionMessage
          icon="error"
          sectionTitle={t("Something went wrong, try again")}
          type="danger"
        >
          {t(
            "Unable to retrieve consents. Please try again later or contact support."
          )}
        </SectionMessage>
      ) : !consents ? (
        <SectionMessage
          icon="warning"
          sectionTitle={t("No consents available")}
          type="warning"
        >
          {t(
            "There are no consents available for this application. Please contact support."
          )}
        </SectionMessage>
      ) : (
        allowZeroConsents && // this would only be true for the regional notices section
        consents &&
        consents?.length < 1 && (
          <SectionMessage
            icon="info"
            sectionTitle={t(
              "No other consents required, please continue to the next step."
            )}
            type="default"
          />
        )
      )}
    </>
  );
}
